import firebase from 'services/firebase';

export function uploadFile(path, file, type, onChange, onError, onSuccess) {
  return new Promise(function(resolve) {
    var uploadTask = firebase
      .storage()
      .ref(path)
      .putString(file, type);

    uploadTask.on(
      'state_changed',
      function(snapshot) {
        onChange(snapshot.bytesTransferred);
      },
      function(err) {
        onError(err);
      },
      function() {
        // Upload completed successfully, now we can get the download URL
        uploadTask.snapshot.ref
          .getDownloadURL()
          .then(url => {
            onSuccess(url);
            resolve();
          })
          .catch(onError);
      }
    );
  });
}

export function deleteFile(url) {
  const ref = firebase.storage().refFromURL(url);
  return ref
    .delete()
    .then(() => console.log('deleted successfully'))
    .catch(e => console.log(e));
}
